import styled from "@emotion/styled";
import { Tabs } from "@mantine/core";

export const SideBarWrapper = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  width: "100%",
  height: "100%",
  backgroundColor: theme.colors.gray[1],
}));

export const SideBarContent = styled.div`
  flex: 1;
  padding: 1rem;
  padding-left: 2rem;
  padding-right: 2rem;
  overflow-y: auto;
  min-height: 0; /* Allow flex item to shrink below content size */
`;

export const TabsListHeader = styled(Tabs.List)(({ theme }) => ({
  backgroundColor: theme.colors.gray[2],
  borderTop: `1px solid ${theme.colors.gray[3]}`,
}));
